import React, { useState } from "react";
import { toast } from "react-toastify";
import { Modal, Spinner } from "react-bootstrap";
import { toastSuccess, toastWarning } from "../Common/ToastAlert";
import { deleteVerifier } from "../../api/network";

const DeleteVerifier = ({
  show,
  onHide,
  data,
  setOpenDeleteModal,
  refetchData,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // handle delete
  const handleDeleteVerifier = async (id) => {
    try {
      setLoading(true);
      const onDelete = await deleteVerifier(id);
      toast.success("Verifier Deleted Successfully", toastSuccess());
      setLoading(false);
      onHide();
      refetchData();
    } catch (err) {
      setError(err);
      toast.warning(
        "Hmm. Something doesn't seem right. Please try again.",
        toastWarning()
      );
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      className="dsm-modal-popup"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Verifier Organization?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to delete this Organization?</p>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="dsm-btn-secondary" onClick={onHide}>
          Cancel
        </button>

        <button
          type="button"
          className="dsm-btn-danger"
          onClick={() => handleDeleteVerifier(data.id)}
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" variant="light" />{" "}
              Deleting...
            </>
          ) : (
            "Delete"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteVerifier;
